export const storageKey = () => `livekid-web-${process.env.VUE_APP_ENV_NAME}`
